module.exports = __webpack_public_path__ + "static/hosting-f705128d9b9ef94fe2e4cfd28da30b21.png";